import React from 'react';
import { useInternationalization } from '@progress/kendo-react-intl';
import LoadingCell from '../../../../ui/table/cells/loadingCell/loadingCell';

import './dateCell.scss';

const DateCell = (props) => {
  if (props.rowType === "groupHeader") {
    return null;
  }

  if (props.dataItem[props.field] === undefined && props.treelist) return <td></td>;
  if (props.dataItem[props.field] === undefined) return <LoadingCell />;

  const intl = useInternationalization();

  return (
    <td>
      <div className="date-cell">{intl.formatDate(new Date(props.dataItem[props.field]), 'd')}</div>
    </td>
  );
};

export default DateCell;
